import { DistanceUnits } from "./DistanceUnits";
import { UnitConversionFactor } from "./UnitConversionFactor";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";

export class DistanceConversionFactors {
    public static readonly KM_TO_MI =
        new UnitConversionFactor(0.6213712, DistanceUnits.KILOMETER, DistanceUnits.MILE);
    public static readonly MI_TO_KM =
        new UnitConversionFactor(1.609344, DistanceUnits.MILE, DistanceUnits.KILOMETER);

    private static readonly group = new UnitConversionFactorGroup(this.KM_TO_MI, this.MI_TO_KM);

    public static get(): UnitConversionFactorGroup {
        return this.group;
    }
}
